import { render, staticRenderFns } from "./ChartOfAccounts.vue?vue&type=template&id=32caf4f1&scoped=true"
import script from "./ChartOfAccounts.vue?vue&type=script&lang=js"
export * from "./ChartOfAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32caf4f1",
  null
  
)

export default component.exports